import { render } from "./SiteLocationZoneCard.vue?vue&type=template&id=b8134bdc&scoped=true"
import script from "./SiteLocationZoneCard.vue?vue&type=script&lang=js"
export * from "./SiteLocationZoneCard.vue?vue&type=script&lang=js"

import "./SiteLocationZoneCard.vue?vue&type=style&index=0&id=b8134bdc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8134bdc"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QCheckbox,QImg});
